import "./assets/styles/global.scss";
import Routes from "./Routes";
import React from 'react';
import NotificationProvider from "./providers/NotificationProvider";
import InfoModalProvider from "./providers/InfoModalProvider";
import { useEffect } from "react";
import AuthProvider from "./providers/AuthProvider";
// Inicializar o Google Analytics 4

import ReactGA from 'react-ga4';


ReactGA.initialize('G-CK9RG9DXFY');

export default function App() {


  return (
    
       
    <NotificationProvider>
    <InfoModalProvider>
      <AuthProvider>
      
          
            <Routes />
          

      </AuthProvider>
    </InfoModalProvider>
  </NotificationProvider>

      
          

  );
}
